import { getJokeUrl } from '@/utils/jokeUrlHelper';

const INDEXNOW_KEY = process.env.VUE_APP_INDEXNOW_KEY;
const HOST = 'humoraq.com';
const KEY_LOCATION = `https://${HOST}/${INDEXNOW_KEY}.txt`;
const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'ar'];

/**
 * Submit a single URL to IndexNow (fire-and-forget)
 * Uses mode: 'no-cors' to avoid CORS blocking on the client side
 */
export const submitUrlToIndexNow = (url) => {
  try {
    if (typeof window === 'undefined' || window.location.hostname !== HOST) {
      return;
    }

    if (!INDEXNOW_KEY) {
      console.warn('IndexNow key not configured');
      return;
    }

    const endpoint = `https://api.indexnow.org/indexnow?url=${encodeURIComponent(url)}&key=${INDEXNOW_KEY}&keyLocation=${encodeURIComponent(KEY_LOCATION)}`;

    fetch(endpoint, { mode: 'no-cors' }).catch(() => {
      // Silently ignore — fire-and-forget
    });
  } catch (error) {
    console.error('IndexNow submission error:', error);
  }
};

/**
 * Submit all language variants of a newly created joke to IndexNow
 * Generates URLs for all 4 languages and submits each one
 */
export const submitNewJokeToIndexNow = (joke) => {
  try {
    if (typeof window === 'undefined' || window.location.hostname !== HOST) {
      return;
    }

    const jokePath = getJokeUrl(joke);

    SUPPORTED_LANGUAGES.forEach((lang) => {
      const fullUrl = `https://${HOST}/${lang}${jokePath}`;
      submitUrlToIndexNow(fullUrl);
    });

    console.log('IndexNow: submitted joke URLs for', joke.id);
  } catch (error) {
    console.error('IndexNow joke submission error:', error);
  }
};
